'use strict';

var TDChartServiceDowFilterFactory = function TDChartServiceDowFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['ServiceDemandDateRangeFilterFactory', 'ServiceDemandClassFilterFactory', 'ServiceDemandNumberOfStopsFilterFactory', 'ServiceDemandTimeOfDayFilterFactory', 'MarketPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function TDChartServiceDowFilter() {
    DemandFilter.call(this, 'service', 'thematic-demand-chart-any-dow');
    this.registerFilters(injectedFilters);
  }
  TDChartServiceDowFilter.constructor = TDChartServiceDowFilter;
  TDChartServiceDowFilter.prototype = Object.create(DemandFilter.prototype);
  return TDChartServiceDowFilter;
};
TDChartServiceDowFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = TDChartServiceDowFilterFactory;